/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConnectedFacility } from '../models/ConnectedFacility';
import type { ConnectionFacilityRelationshipStatusWrite } from '../models/ConnectionFacilityRelationshipStatusWrite';
import type { HealthcareEntity } from '../models/HealthcareEntity';
import type { HealthcareFacility } from '../models/HealthcareFacility';
import type { PaginatedHealthcareFacilityList } from '../models/PaginatedHealthcareFacilityList';
import type { PatchedHealthcareEntity } from '../models/PatchedHealthcareEntity';
import type { PatchedSimpleHealthcareFacility } from '../models/PatchedSimpleHealthcareFacility';
import type { SimpleHealthcareFacility } from '../models/SimpleHealthcareFacility';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HealthcareEntityService {

    /**
     * @returns HealthcareEntity
     * @throws ApiError
     */
    public static healthcareEntityRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<HealthcareEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns HealthcareEntity
     * @throws ApiError
     */
    public static healthcareEntityUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: HealthcareEntity,
    }): CancelablePromise<HealthcareEntity> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare_entity/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns HealthcareEntity
     * @throws ApiError
     */
    public static healthcareEntityPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedHealthcareEntity,
    }): CancelablePromise<HealthcareEntity> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare_entity/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns PaginatedHealthcareFacilityList
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesList({
        healthcareEntity,
        limit,
        notProvider,
        offset,
        ordering,
        provider,
        rep,
    }: {
        healthcareEntity?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        notProvider?: string,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: string,
        rep?: string,
    }): CancelablePromise<PaginatedHealthcareFacilityList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/facilities',
            query: {
                'healthcare_entity': healthcareEntity,
                'limit': limit,
                'not_provider': notProvider,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'rep': rep,
            },
        });
    }

    /**
     * @returns SimpleHealthcareFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesCreate({
        requestBody,
    }: {
        requestBody: SimpleHealthcareFacility,
    }): CancelablePromise<SimpleHealthcareFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare_entity/facilities',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Mark Connection Cleared by ID
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesMarkApprovedCreate({
        connectedFacilityId,
    }: {
        connectedFacilityId: string,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare_entity/facilities/{connected_facility_id}/mark_approved',
            path: {
                'connected_facility_id': connectedFacilityId,
            },
        });
    }

    /**
     * Mark Connection Pending Clearance by ID
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesMarkPendingCreate({
        connectedFacilityId,
    }: {
        connectedFacilityId: string,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare_entity/facilities/{connected_facility_id}/mark_pending',
            path: {
                'connected_facility_id': connectedFacilityId,
            },
        });
    }

    /**
     * Mark Connection Not Cleared by ID
     * @returns ConnectedFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesMarkRejectedCreate({
        connectedFacilityId,
        requestBody,
    }: {
        connectedFacilityId: string,
        requestBody?: ConnectionFacilityRelationshipStatusWrite,
    }): CancelablePromise<ConnectedFacility> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/healthcare_entity/facilities/{connected_facility_id}/mark_rejected',
            path: {
                'connected_facility_id': connectedFacilityId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns HealthcareFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<HealthcareFacility> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/facilities/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns SimpleHealthcareFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: SimpleHealthcareFacility,
    }): CancelablePromise<SimpleHealthcareFacility> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/healthcare_entity/facilities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SimpleHealthcareFacility
     * @throws ApiError
     */
    public static healthcareEntityFacilitiesPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedSimpleHealthcareFacility,
    }): CancelablePromise<SimpleHealthcareFacility> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/healthcare_entity/facilities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get Provider Information for a Healthcare Organization
     * @returns any
     * @throws ApiError
     */
    public static healthcareEntityMarketplaceProviderRetrieve({
        provider,
    }: {
        provider: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/healthcare_entity/marketplace-provider/{provider}/',
            path: {
                'provider': provider,
            },
        });
    }

}
